export default "__VITE_ASSET__BGfHW3dy__"